import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { QuotesData, UseQuotesOptions } from "@/types/quote";
import { FilteredQuoteResponse } from "@/types/rpcTypes";

export function useQuotesFetch(options: UseQuotesOptions) {
  const {
    searchQuery = "",
    page = 1,
    pageSize = 10,
    sortField = "created_at",
    sortOrder = "desc",
    categoryId,
    showUncategorized = false,
    showDuplicates = false
  } = options;

  return useQuery<QuotesData, Error>({
    queryKey: ["quotes", searchQuery, categoryId, page, pageSize, sortField, sortOrder, showUncategorized, showDuplicates],
    queryFn: async () => {
      const { data, error } = await supabase
        .rpc<FilteredQuoteResponse>('get_filtered_quotes', {
          search_term: searchQuery ? `%${searchQuery}%` : null,
          category_filter: categoryId,
          show_uncategorized: showUncategorized,
          show_duplicates: showDuplicates,
          sort_column: sortField,
          sort_direction: sortOrder,
          page_number: page,
          page_size: pageSize
        });

      if (error) throw error;

      const quotes = data || [];
      const totalCount = quotes.length > 0 ? quotes[0].total_count : 0;
      const totalPages = Math.ceil(totalCount / pageSize);

      return {
        quotes: quotes.map(quote => ({
          id: quote.id,
          content: quote.content,
          author: quote.author || "",
          source: quote.source || "",
          created_at: quote.created_at,
          categories: quote.categories || []
        })),
        totalPages,
        currentPage: page
      };
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
